var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMyListOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.924 13.026c-.82 5.16-7.898 10.668-10.837 12.754-2.98-2.112-10.181-7.697-10.997-12.82-.236-1.486.088-2.783.995-3.967C7.043 7.74 8.23 7.107 9.62 7.107c.165 0 .333.01.505.027 2.293.24 4.344 2.013 4.883 3.146a1 1 0 00.897.57l.176.001h.005a.999.999 0 00.904-.57c.538-1.134 2.59-2.906 4.884-3.147 1.608-.175 2.968.456 4.04 1.86.92 1.202 1.25 2.521 1.01 4.032m.58-5.248c-1.9-2.482-4.221-2.802-5.838-2.633-2.293.24-4.424 1.583-5.667 3.047-1.242-1.464-3.374-2.808-5.666-3.047-1.612-.168-3.94.151-5.838 2.633-1.239 1.62-1.704 3.47-1.382 5.496.973 6.102 9 12.208 12.408 14.55a.998.998 0 001.132 0c3.357-2.308 11.268-8.338 12.245-14.484.328-2.052-.142-3.923-1.395-5.562",
    fill: props.color
  })));
}

export default SvgIconMyListOutline;